import React from 'react'
import { Button, Container, Row, Card, Col, Tabs, Tab } from 'react-bootstrap';
import styles from './Measures.module.scss';
import AHRQLife from '../../img/AHRQlifecycle.png';
import { data } from '../data';

const QIResources = () => {

    return (<>

        <Container className={styles.outerContainer}>
            <h1 className="centerText mb-5">Quality Indicator Resources</h1>
            {data.QI.map((information, index) => (
                <div key={index}>
                    <Tabs defaultActiveKey="methodology" className={'qiTabs'}>
                        <Tab eventKey="methodology" title="AHRQ QI Methodology">
                            <Container className='outerContainer'>
                                <Row>
                                    {information.methods.map((info) => (
                                        <Col className={styles.columns} xs={12} sm={6} md={4}>
                                            <Card className={styles.cards}>
                                                <Card.Header className={styles.cardHeader} >
                                                    <a href={info.url}><h5>{info.title}</h5></a>{info.date ? <h6>{info.date}</h6> : null}
                                                </Card.Header>
                                                <Card.Body className={styles.lightGrey}>
                                                    <Card.Text>
                                                        <div dangerouslySetInnerHTML={{ __html: info.desc }} />
                                                    </Card.Text>
                                                </Card.Body>
                                                <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                                                    <Button className={styles.ctaBtn} href={info.url}>View</Button>
                                                </div>
                                            </Card>
                                        </Col>
                                    )
                                    )}
                                </Row>
                            </Container>

                        </Tab>
                        <Tab eventKey="reporting" title="QI Reporting/User Tips">
                            <Container className={styles.cardContainer}>
                                <Row>
                                    {information.reporting.map((info) => (<>
                                        {
                                            info.category && info.category.includes("main") ?

                                                <Col className={styles.columns} xs={12} sm={6} md={4}>
                                                    <Card className={styles.cards}>
                                                        <Card.Header className={styles.cardHeader} >
                                                            <a href={info.url1}><h5>{info.title}</h5></a>{info.date ? <h6>{info.date}</h6> : null}
                                                        </Card.Header>
                                                        <Card.Body className={styles.lightGrey}>
                                                            <Card.Text>
                                                                {info.desc}
                                                            </Card.Text>
                                                        </Card.Body>
                                                        <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                                                            <Button className={styles.ctaBtn + ' ' + 'my-2'} href={info.url1}>{info.cta1}</Button>
                                                            {info.cta2 ?
                                                                <Button className={styles.ctaBtn + ' ' + 'my-2'} href={info.url2}>{info.cta2}</Button>
                                                                : null}
                                                            {info.cta3 ?
                                                                <Button className={styles.ctaBtn + ' ' + 'my-2'} href={info.url3}>{info.cta3}</Button>
                                                                : null}
                                                        </div>
                                                    </Card>
                                                </Col> : null}
                                    </>)
                                    )}
                                </Row>
                                <Row className='mt-3'>
                                    <h4>AHRQ QIs for Home and Community Based Services (HCBS)</h4>
                                    <p className='mb-4'>This set of indicators reflect the health and well-being of beneficiaries receiving home and community-based services (HCBS) through state Medicaid programs. They focus on potentially preventable hospitalizations. For additional information on the development of the HCBS QIs, view the resources below:</p>
                                    {information.reporting.map((info) => (<>
                                        {
                                            info.category && info.category.includes("hcbs") ?

                                                <Col className={styles.columns} xs={12} sm={6} md={4}>
                                                    <Card className={styles.cards}>
                                                        <Card.Header className={styles.cardHeader} >
                                                            <a href={info.url1}><h5>{info.title}</h5></a>{info.date ? <h6>{info.date}</h6> : null}
                                                        </Card.Header>
                                                        <Card.Body className={styles.lightGrey}>
                                                            <Card.Text>
                                                                {info.desc}
                                                            </Card.Text>
                                                        </Card.Body>
                                                        <div className={'p-2 centerText' + ' ' + styles.lightGrey} >
                                                            <Button className={styles.ctaBtn + ' ' + 'my-2'} href={info.url1}>{info.cta1}</Button>
                                                            {info.cta2 ?
                                                                <Button className={styles.ctaBtn + ' ' + 'my-2'} href={info.url2}>{info.cta2}</Button>
                                                                : null}
                                                            {info.cta3 ?
                                                                <Button className={styles.ctaBtn + ' ' + 'my-2'} href={info.url3}>{info.cta3}</Button>
                                                                : null}
                                                        </div>
                                                    </Card>
                                                </Col> : null}
                                    </>)
                                    )}
                                </Row>
                            </Container>
                        </Tab>
                        <Tab eventKey="cycle" title="AHRQ QI Life Cycles" >
                            <div className="mt-4 d-none d-md-block">
                                <h4 className='centerText'>Life Cycle of the AHRQ QIs</h4>
                                <p className='centerText bold'>Developing the Indicators</p>
                                <p className='centerText body2'>The AHRQ QI measure development process involves four phases.</p>
                                <Row >
                                    <Col md={4}>
                                        <div className={styles.phase1 + ' ' + 'mb-5'} >
                                            <h4>Phase 1: Candidate Indicator Development</h4>
                                            <ul>
                                                <li>Identify candidate indicators within areas of interest.</li>
                                                <li>Review literature.</li>
                                                <li>Finalize specifications.</li>
                                                <li>Summarize evidence.</li>
                                            </ul>
                                        </div>
                                        <div className={styles.phase4}>
                                            <h4>Phase 4: Retire Indicators</h4>
                                            <ul>
                                                <li>Review evidence on the use of the indicator and determine that retirement is needed.</li>
                                                <li>Remove coding from software and user documentation.</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className='mt-5 flex'>
                                            <img className={styles.arhqCycleMobile} src={AHRQLife} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className={styles.phase2 + ' ' + 'mb-5'} >
                                            <h4>Phase 2: Implement New Indicator</h4>
                                            <ul>
                                                <li>Code the new indicator into the software.</li>
                                                <li>Test the new indicator.</li>
                                                <li>Develop user documentation.</li>
                                            </ul>
                                        </div>
                                        <div className={styles.phase3}>
                                            <h4>Phase 3: Maintain Existing Indicators</h4>
                                            <ul>
                                                <li>Review evidence on the use of the indicator.</li>
                                                <li>Update technical specifications.</li>
                                                <li>Periodic review by clinical panels.</li>
                                                <li>Consider new data and methodological advances.</li>

                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            <div className="mt-4 d-block d-md-none">
                                <h4 className='centerText'>Life Cycle of the AHRQ QIs</h4>
                                <p className='centerText bold'>Developing the Indicators</p>
                                <p className='centerText subtitle'>The AHRQ QI measure development process involves four phases.</p>
                                <Row >
                                    <Col className='mb-4' md={12}>
                                        <div >
                                            <img className={styles.arhqCycleMobile} src={AHRQLife} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className={styles.phase1 + ' ' + 'mb-5'} >
                                            <h4>Phase 1: Candidate Indicator Development</h4>
                                            <ul>
                                                <li>Identify candidate indicators within areas of interest.</li>
                                                <li>Review literature.</li>
                                                <li>Finalize specifications.</li>
                                                <li>Summarize evidence.</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className={styles.phase2 + ' ' + 'mb-5'} >
                                            <h4>Phase 2: Implement New Indicator</h4>
                                            <ul>
                                                <li>Code the new indicator into the software.</li>
                                                <li>Test the new indicator.</li>
                                                <li>Develop user documentation.</li>
                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className={styles.phase3 + ' ' + 'mb-5'}>
                                            <h4>Phase 3: Maintain Existing Indicators</h4>
                                            <ul>
                                                <li>Review evidence on the use of the indicator.</li>
                                                <li>Update technical specifications.</li>
                                                <li>Periodic review by clinical panels.</li>
                                                <li>Consider new data and methodological advances.</li>

                                            </ul>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className={styles.phase4 + ' ' + 'mb-5'}>
                                            <h4>Phase 4: Retire Indicators</h4>
                                            <ul>
                                                <li>Review evidence on the use of the indicator and determine that retirement is needed.</li>
                                                <li>Remove coding from software and user documentation.</li>
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="mb-5 mt-4">
                                <p>These phases and processes sometimes may require modifications to meet the needs of indicator development in new areas. For a more in-depth explanation, see the reports below.</p>
                            </div>
                            <Container className={styles.cardContainer}>
                                <Row>
                                    {information.cycle.map((info) => (
                                        <Col className={styles.columns} xs={12} sm={6} md={4}>
                                            <Card className={styles.cards}>
                                                <Card.Header className={styles.cardHeader} >
                                                    <h5>{info.title}</h5>{info.date ? <h6>{info.date}</h6> : null}
                                                </Card.Header>
                                                <Card.Body className={styles.lightGrey}>
                                                    <Card.Text>
                                                        <div dangerouslySetInnerHTML={{ __html: info.desc }} />
                                                    
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    )
                                    )}
                                </Row>
                            </Container>
                        </Tab>
                    </Tabs>
                </div>
            )
            )}
        </Container>
    </>)
}

export default QIResources;